<template>
  <div>
    <app-heading
      :text="'NBN Appointments Management'"
      :heading="'main'"
    ></app-heading>
    <v-row class="mb-4">
      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <v-btn
          class="primary"
          @click="reserveAppointment({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
        >Reserve an Appointment</v-btn
        >
        &nbsp;
        <v-btn
          class="primary"
          @click="queryNbnAppointment({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'mt-4' : 'mt-6'"
        >Query available Slots</v-btn
        >
      </v-col>
    </v-row>
    <v-divider class="mt-6 mb-4"></v-divider>

    <v-row class="mb-4">

      <v-col cols="12" sm="3" :class="$vuetify.breakpoint.xs ? 'pt-0' : ''">
        <app-search @search="onGridSearch"></app-search>
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      @cellClicked="onRowClicked"
      rowSelection="single"
    ></ag-grid-vue>
    <div class="text-center">
      <v-pagination
        v-model="page"
        total-visible="7"
        :length="nbnDataOptions.totalPages"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
        @input="paginationChange"
      ></v-pagination>
    </div>

    <query-nbn-appointment
      ref="queryNbnAppointment"
      :showQueryAppointment="showQueryAppointment"
      @closeQuery="closeQueryAppointment()"
    ></query-nbn-appointment>

    <reserve-nbn-appointment
      ref="reserveAppointment"
      :showNewAppointment="showNewAppointment"
      :businessOptionEnabled="businessOptionEnabled"
      @close="closeNewAppointment()"
    ></reserve-nbn-appointment>

    <view-nbn-appointment
      ref="viewNbnAppointment"
      v-bind:viewNbnAppointment="viewNbnAppointment"
      :appointmentData="appointmentData"
      @close-appointment="onClose"
    ></view-nbn-appointment>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { formatDateTime} from "@/plugins/global-functions";
export default {
  name: "NbnAppointmentManagement",
  components: { AgGridVue },
  data: () => ({
    showNewAppointment: false,
    showQueryAppointment:false,
    filterCompleted: false,
    filterCancelled: false,
    filterRejected: false,
    isEditing: false,
    viewNbnAppointment: false,
    appointmentData: {},
    statusFilter: -1,
    pageSize: 50,
    keyword: null,
    items: [],
    page: 1,
    parties:[],
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: "",
    },
    nbnDataOptions:{},
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
    columnDefs: [
      {
        headerName: "Order ID",
        field: "nbnOrderID",
      },
      {
        headerName: "Appointment ID",
        field: "appointmentId",
      },
      {
        headerName: "Appointment Location ID",
        field: "serviceLocationId",
      },
      {
        headerName: "Appointment Time",
        field: "startDatetime",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: "Planned Completion Date",
        field: "endDatetime",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: "Status",
        field: "status"
      },
      // {
      //   headerName: "Ticket ID",
      //   field: "jsonData",
      //   cellRenderer: function (data) {
      //     let parsedData = JSON.parse(data.value);
      //     let newItem = parsedData.CustomerReference;
      //     if (parsedData.CustomerReference.includes("_")) {
      //       newItem = parsedData.CustomerReference.slice(
      //         newItem.indexOf("_") + 1,
      //         parsedData.length
      //       );
      //     }
      //     return `<a href="https://vonex.kayako.com/agent/conversations/${newItem}" class="ticket-link" target="_blank">${parsedData.CustomerReference}</a>`;
      //   },
      // },
    ],
  }),
  computed: {
    filteredItems: function () {
      let vm = this;
      // let items = vm.appointments;

      // if (!vm.filterCompleted) items = items.filter((x) => x.status != 4);
      //
      // if (!vm.filterCancelled) items = items.filter((x) => x.status != 0);
      //
      // if (!vm.filterRejected) items = items.filter((x) => x.status != 1);

      return vm.items;
    },
    businessOptionEnabled() {
      let vm =this;
      return vm.parties.length > 0;
    },
  },
  methods:{
    reserveAppointment(){
      let vm = this;
      vm.$refs.reserveAppointment.showNewAppointment = true;
    },
    queryNbnAppointment(){
      let vm = this;
      vm.$refs.queryNbnAppointment.showQueryAppointment = true;
    },
    closeNewAppointment() {
      let vm = this;
      vm.$refs.reserveAppointment.showNewAppointment = false;
      vm.showNewAppointment = false;
    },
    closeQueryAppointment(){
      let vm = this;
      vm.$refs.queryNbnAppointment.showQueryAppointment = false;
      vm.showQueryAppointment = false;
    },
    onGridSearch(keyword) {
      let vm = this;
      if (vm.statusFilter === null) vm.statusFilter = -1;
      vm.paging.keyword = keyword;
      vm.keyword = keyword;

      vm.setAppointmentSearch({
        keyword: vm.keyword,
        statusFilter: parseInt(vm.statusFilter),
        pageSize: parseInt(vm.pageSize),
        pageNumber:vm.paging.pageNo
      });

      var search = {
        keyword: keyword,
        statusFilter: -1,
        pageSize: 50,
        pageNumber:vm.paging.pageNo
      };

      clearTimeout(vm._timerId);
      vm._timerId = setTimeout(() => {
        if(vm.keyword.length >= 4)
          vm.getNbnAppointments(search)
            .then((data) => {
              vm.items = data.data.items;
              vm.gridApi.sizeColumnsToFit();
            })
            .catch(() => {});
      });

    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      args.api.sizeColumnsToFit();
    },
    onRowClicked(args) {
      let vm = this;
      var payload = {appointmentId:args.data.appointmentId}
      vm.getNbnAppointment(payload)
        .then((data) => {
          vm.appointmentData = data.data;
          vm.viewNbnAppointment = true;
        })
        .catch(() => {});
      // vm.viewAppointment = true;
      // vm.appointmentData = args.data;
    },
    onClose() {
      let vm = this;
      vm.viewNbnAppointment = false;
      vm.$refs.viewNbnAppointment.viewNbnAppointment = false;
    },
    paginationChange(val){
      let vm = this;
      vm.paging.pageNo = val;
      var search = {
        keyword: null,
        statusFilter: -1,
        pageSize: vm.paging.pageSize,
        pageNumber:vm.paging.pageNo
      };

      vm.getNbnAppointments(search)
        .then((data) => {
          vm.items = data.data.items;
          vm.nbnDataOptions = data.data;
        })
        .catch(() => {});
    },
  },
  beforeMount() {
    let vm = this;

    vm.setAppointmentSearch({
      keyword: null,
      statusFilter: -1,
      pageSize: 25,
      pageNumber:1,
    });

    var search = {
      keyword: null,
      statusFilter: -1,
      pageSize: 25,
      pageNumber:1,
    };

    vm.getNbnAppointments(search)
      .then((data) => {
        vm.items = data.data.items;
        vm.nbnDataOptions = data.data;
      })
      .catch(() => {});
    var partySearch = {
      keyword: null,
      statusFilter: -1,
      pageSize: 100,
      pageNumber: 1,
      wholesalerAccountNumber: vm.wholesalerAccount
    }
    vm.getOrganisationsAsync(partySearch)
      .then((data) => {
        vm.parties = data.data.items;
      })
      .catch(() => {});
  },
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
}
</script>

<style scoped>

</style>
